import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "alert-popup-view"
}
const _hoisted_2 = { class: "alert-back" }

import {computed} from 'vue';
import {store} from '@/store';
import AlertComp from '@/components/pages/popup/comp/AlertComp.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'AlertPopupView',
  setup(__props) {

const alertList = computed(() => {
  return store.state.popup.alert;
});

const onConfirm = () => {
  store.state.popup.alert.pop()
}
const curAlert = computed(() => {
  return alertList.value[alertList.value.length - 1]
})

return (_ctx: any,_cache: any) => {
  return (_unref(alertList).length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_unref(curAlert))
            ? (_openBlock(), _createBlock(AlertComp, {
                key: 0,
                text: _unref(curAlert).text,
                options: _unref(curAlert).options,
                onConfirm: onConfirm
              }, null, 8, ["text", "options"]))
            : _createCommentVNode("", true)
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})